import { Loader2 } from 'lucide-react'
import { Suspense } from 'react'
import { SchemaManager } from '@/components/schema/schema-manager'

function SchemaSkeleton() {
  return (
    <div className="flex items-center justify-center min-h-[60dvh] md:min-h-screen bg-background">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="size-8 animate-spin text-muted-foreground" />
        <p className="text-muted-foreground text-sm">Loading Schema...</p>
      </div>
    </div>
  )
}

export default function SchemaPage() {
  return (
    <Suspense fallback={<SchemaSkeleton />}>
      <SchemaManager />
    </Suspense>
  )
}
